import React from 'react';
import Stylesheet from './Tbody.module.css';
import Record from '../Record/Record';
import Spinner from '../../../Spinner/Image/Image';
import { TableContext } from '../../context/table';
import { QueryContext } from '../../context/query';
import Button from '../../../../elements/Button/Button';

const Tbody = (props) => {
    let table = null;
    let query = null;
    const init = (tableContext, queryContext) => {
        table = tableContext;
        query = queryContext;
    }
    const getRecordSet = _ => {
        // search records take priority before all records sets
        if (query.search.records.length > 0) return query.search.records;
        // report records take priority before all records
        else if (query.report.records.length > 0) return query.report.records;
        // use all records
        else return table.records;
    }
    const getRecords = _ => {
        let recordSet = getRecordSet();
        // filter records per record limit set
        let result = [];
        for (let index = 0; index < table.filter.recordLimit; index++)
            if (recordSet[index]) result.push(recordSet[index]);
        return result;
    }
    const content = records => {
        if (!records) {
            return (
                <div className={Stylesheet.Loading}>
                    <Spinner />
                </div>
            )
        }
        if (records.length === 0) {
            return (
                <div className={Stylesheet.NoRecords}>
                    <h4>no records for table yet!</h4>
                </div>
            )
        }
        return (
            <React.Fragment>
                {getRecords().map((value, index) => (
                    <Record key={index} metadata={value} />
                ))}
                <div className={Stylesheet.LoadMore}>
                    <Button secondary disabled={table.filter.recordLimit > table.records.length}
                    onClick={_ => query.setRecordLimit(table.filter.recordLimit+15)}>show more records</Button>
                </div>
            </React.Fragment>
        )
    }
    
    return (
        <TableContext.Consumer>
            {table => (
                <QueryContext.Consumer>
                    {query => (
                        <div className={Stylesheet.Container}>
                            {init(table, query)}
                            {content(query.report.report ? query.report.records : table.records)}
                        </div>
                    )}
                </QueryContext.Consumer>
            )}
        </TableContext.Consumer>
    )

}


export default Tbody;